// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.Demochat_outerContainer__NbVSX {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Full height for centering */
  background-color: #edf6f778; /* Light background for contrast */
}

.Demochat_chatContainer__R157M {
  width: 100%; /* Full width for chat container */
  height: 100%; /* Full height for chat container */
  max-width: 1300px;
  max-height: 1200px;
  overflow: hidden !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */
  display: flex;
  flex-direction: column !important;
}

.Demochat_header__a6U7y {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  background-color: #ffffff; /* White background for the header */
  border-bottom: 1px solid #e0e0e0; /* Separator line */
}

.Demochat_botInfo__cO2EE {
  display: flex;
  align-items: center;
}

.Demochat_botIcon__X7L6\\+ {
  width: 50px; /* Fixed size for consistency */
  height: 50px;
  border-radius: 50%; /* Circular icon */
  margin-right: 5px; /* Space between icon and text */
}

.Demochat_botDetails__SPoI5 {
  display: flex;
  flex-direction: column; /* Stack name and status */
}

.Demochat_botName__5m6zN {
  font-size: 17px;
  font-weight: bold; /* Bold font for bot name */
}

.Demochat_onlineStatus__0vNuK {
  font-size: 0.775rem; /* Smaller font for online status */
  color: #6c757d; /* Gray color for status */
  display: flex; /* Use flexbox to align dot and text */
  align-items: center; /* Center vertically */
}

.Demochat_statusDot__roNAa {
  margin-left: 5px;
  width: 8px; /* Size of the dot */
  height: 8px; /* Size of the dot */
  background-color: #4caf50; /* Green color */
  border-radius: 50%; /* Make it circular */
  margin-right: 5px; /* Space between dot and text */
}

.Demochat_chatWindow__Qpnh0 {
  padding: 1rem; /* Space for chat messages */
  flex-grow: 1; /* Take remaining height */
  overflow-y: auto; /* Scrollable chat window */
  overflow-x: hidden;
  background-color: #ffffff; /* White background for chat */
}

.Demochat_messageContainer__\\+-7tl {
  display: flex;
  margin: 10px 0; /* Adjusted margin for closer spacing */
}

.Demochat_leftMessage__Nh8mp {
  justify-content: flex-start; /* Align left for bot messages */
  text-align: start;
}

.Demochat_rightMessage__L5bRP {
  justify-content: flex-end; /* Align right for user messages */
  text-align: start;
}

.Demochat_message__5N\\+NZ {
  padding: 15px 15px; 
  border-radius: 10px;
  align-items: center; 
  display: flex;
  max-width: 50%; 
  color: #333;
  position: relative; 
  word-wrap: break-word;
  overflow-wrap: anywhere; 
  white-space: pre-wrap; 
}

.Demochat_soundButton__cZR2x {
  margin-left: 10px; /* Add space between the text and the sound icon */
  cursor: pointer;
  transition: color 0.3s;
  align-self: flex-end;
}

.Demochat_soundButton__cZR2x:hover {
  color: #333;
}

.Demochat_botMessage__TYkOS {
  background-color: #ebeaea; 
}

.Demochat_userMessage__9LfK0 {
  background-color: #c8e6c9; 
}

.Demochat_avatar__HBPcT {
  width: 50px; /* Avatar size */
  height: 50px;
  border-radius: 50%; /* Circular avatar */
  margin: 0 10px; /* Space around avatar */
}

/* Input Section */
.Demochat_inputSection__3YWwN {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  background-color: #ffffff;
  border-radius: 0 0 20px 20px;
  position: sticky;
  bottom: 0;
}

/* Wrapper for the custom input */
.Demochat_inputWrapper__0JvZm {
  display: flex;
  align-items: flex-end;
  padding: 4px 8px;
  /* border: 1px solid #e0e0e0; */
  border-radius: 20px;
  background-color: #ebeaea;
  margin-right: 16px; 
  position: relative;
  width: 100%;
  /* min-width: 300px; */
  max-width: 1000px; 
  margin: 0 auto;
}

/* Custom input styling */
.Demochat_customInput__BhjH8 {
  flex-grow: 1;
  border: transparent;
  outline: none;
  background-color: transparent;
  padding: 8px;
  font-size: 1rem;
  line-height: 24px;
  resize: none; /* Disable manual resizing */
  overflow-y: auto; /* Add scrollbar if content overflows */
  color: inherit;
}

/* Attachment button styling */
.Demochat_attachButton__Yv4Xc {
  color: inherit;
  margin-right: 8px;
}


/* Mic button positioning */
.Demochat_micButton__X4rr4 {
  color: inherit;
  margin-right: 8px;
  transition: all 0.3s ease;
}

/* Send Button styling */
.Demochat_sendButton__awPyU {
  background-color: #c9d1d8;
  color: #000;
  border: none;
  border-radius: 50%;
  padding: 10px;
  width: 40px;
  height: 40px;
  transition: background-color 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.Demochat_disabledButton__UcTrm {
  opacity: 0.5;
  cursor: not-allowed; 
}


/* Dark mode styling for input wrapper */
.Demochat_darkInputWrapper__AcBnq {
  background-color: #333;
  border: 1px solid #555;
}


/* Pulse effect when listening */
.Demochat_micButton__X4rr4.Demochat_listening__gv7mR {
  color: #ff4081; /* Color to indicate active listening */
  animation: Demochat_pulse__T4rvJ 1s infinite;
}

/* Add pulse effect around the mic icon when listening */
.Demochat_listeningPulse__uRuxO {
  border: 3px solid rgba(0, 150, 255, 0.5);
  border-radius: 50%;
  padding: 8px;
  animation: Demochat_pulse__T4rvJ 1.5s infinite;
}

/* Pulsing animation for listening mode */
@keyframes Demochat_pulse__T4rvJ {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Listening waveform animation */
@keyframes Demochat_wave__wSkD4 {
  0%,
  100% {
    transform: scaleY(1);
  }
  50% {
    transform: scaleY(1.5);
  }
}

.Demochat_listeningWave__bRg3z {
  display: flex;
  gap: 2px;
}

.Demochat_waveBar__LZHSz {
  width: 5px;
  height: 16px;
  background: #2196f3;
  animation: Demochat_wave__wSkD4 1s infinite ease-in-out;
  animation-delay: calc(0.2s * var(--i));
}

.Demochat_inputWrapper__0JvZm:focus-within {
  border-color: #000000;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}

.Demochat_spinner__29N-6 {
  width: 20px;
  height: 20px;
  border: 3px solid #ddd;
  border-top: 3px solid #3f51b5; /* or any color matching your theme */
  border-radius: 50%;
  animation: Demochat_spin__B\\+K18 1s linear infinite;
}

@keyframes Demochat_spin__B\\+K18 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Hover effect for send button */
.Demochat_sendButton__awPyU:hover {
  background-color: #0056b3;
}

/* Custom scrollbar for WebKit browsers (Chrome, Safari) */
.Demochat_chatWindow__Qpnh0::-webkit-scrollbar {
  width: 10px; /* Width of the scrollbar */
  border-radius: 10px; /* Rounded corners */
}

.Demochat_chatWindow__Qpnh0::-webkit-scrollbar-thumb {
  background-color: #007bff; /* Color of the scrollbar thumb */
  border-radius: 10px; /* Rounded corners for the thumb */
}

.Demochat_chatWindow__Qpnh0::-webkit-scrollbar-thumb:hover {
  background-color: #0056b3; /* Darker color on hover */
}

/* Custom scrollbar for Firefox */
.Demochat_chatWindow__Qpnh0 {
  scrollbar-width: thin; /* Make the scrollbar thinner */
  scrollbar-color: #007bff #f0f4f8; /* Thumb color and track color */
}

.Demochat_chatWindow__Qpnh0::-moz-scrollbar {
  border-radius: 10px; /* Rounded corners for Firefox */
}

/* Optional: Adjust the appearance of the scrollbar track in Firefox */
.Demochat_chatWindow__Qpnh0::-moz-scrollbar-track {
  background: #f0f4f8; /* Track color */
}

.Demochat_chatWindow__Qpnh0::-moz-scrollbar-thumb {
  background-color: #007bff; /* Color of the scrollbar thumb */
  border-radius: 10px; /* Rounded corners for the thumb */
}

.Demochat_chatWindow__Qpnh0::-moz-scrollbar-thumb:hover {
  background-color: #0056b3; /* Darker color on hover */
}

/* Add style for the delete icon */
.Demochat_deleteIcon__n2XTs {
  cursor: pointer;
}

.Demochat_backButtonContainer__AJQP4 {
  display: flex;
  justify-content: center; /* Center horizontally */
  align-items: center; /* Center vertically */
  padding: 1rem;
  background-color: #f9f9f9; /* Light background for the button section */
  width: 100%; /* Ensure the button container takes up full width */
}

.Demochat_backButton__WGrJc {
  background-color: #c9d1d8 !important; /* Color of the Back to Home button */
  color: #000 !important;
  border-radius: 20px !important;
  padding: 10px 20px !important;
  text-transform: none; /* Disable uppercase */
}

/* .typingIndicator {
  display: flex;
  gap: 5px;
  margin: 0.5rem 1rem;
}

.typingDot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #888;
  animation: typing 0.8s infinite;
}

.typingDot:nth-child(2) {
  animation-delay: 0.2s;
}

.typingDot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes typing {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
} */

.Demochat_typingDots__Xzdx6 {
  display: flex;
  gap: 4px;
}

.Demochat_dot__tXY9S {
  width: 8px;
  height: 8px;
  background-color: #aaa;
  border-radius: 50%;
  animation: Demochat_blink__6oOqt 1s infinite;
}

.Demochat_dot__tXY9S:nth-child(2) {
  animation-delay: 0.2s;
}

.Demochat_dot__tXY9S:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes Demochat_blink__6oOqt {
  0%,
  20%,
  100% {
    opacity: 0.2;
  }
  50% {
    opacity: 1;
  }
}

/* Responsive positioning if needed */
@media (max-width: 600px) {
  .Demochat_backButtonContainer__AJQP4 {
    padding: 0.5rem;
  }

  .Demochat_backButton__WGrJc {
    font-size: 0.875rem;
  }
}

/* Dark mode styles */
.Demochat_dark__GagoO {
  background-color: #121212; /* Dark background */
  color: #f1f1f1; /* Light text */
}

.Demochat_dark__GagoO .Demochat_chatContainer__R157M {
  background-color: #1e1e1e; /* Darker chat container */
  color: #f1f1f1;
}

.Demochat_dark__GagoO .Demochat_chatWindow__Qpnh0 {
  background-color: #1e1e1e;
}

/* .dark .customInput {
  background-color: #333333; 
  border-color: #444444;
  color: #ffffff;
} */

.Demochat_dark__GagoO .Demochat_customInput__BhjH8::placeholder {
  color: #fff;
}

.Demochat_dark__GagoO .Demochat_attachButton__Yv4Xc {
  color: #fff;
}

.Demochat_dark__GagoO .Demochat_sendButton__awPyU {
  background-color: #444444 !important; /* Darker send button */
}

.Demochat_themeToggleIcon__sBVrN {
  color: #ffeb3b; /* Yellow for light mode */
}

.Demochat_dark__GagoO .Demochat_themeToggleIcon__sBVrN {
  color: #ffffff; /* White for dark mode */
}

.Demochat_dark__GagoO .Demochat_inputSection__3YWwN {
  background-color: #1e1e1e;
}

.Demochat_dark__GagoO .Demochat_header__a6U7y {
  background-color: #1e1e1e;
}

.Demochat_dark__GagoO .Demochat_backButtonContainer__AJQP4 {
  background-color: #1e1e1e;
}

.Demochat_dark__GagoO .Demochat_inputWrapper__0JvZm:focus-within {
  border-color: #fff;
  box-shadow: 0 0 5px rgba(255, 255, 255, 0.5);
}

.Demochat_dark__GagoO .Demochat_deleteIcon__n2XTs {
  color: #fff;
}

.Demochat_dark__GagoO .Demochat_sendButton__awPyU {
  background-color: #333333 !important;
  color: #fff !important;
}

.Demochat_dark__GagoO .Demochat_backButton__WGrJc {
  background-color: #333333 !important; /* Color of the Back to Home button */
  color: #fff !important;
}

.Demochat_dark__GagoO .Demochat_micButton__X4rr4 {
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/component/dashboard/chat/Demochat.module.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,8BAA8B;EAC7C,2BAA2B,EAAE,kCAAkC;AACjE;;AAEA;EACE,WAAW,EAAE,kCAAkC;EAC/C,YAAY,EAAE,mCAAmC;EACjD,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,wCAAwC,EAAE,4BAA4B;EACtE,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,yBAAyB,EAAE,oCAAoC;EAC/D,gCAAgC,EAAE,mBAAmB;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW,EAAE,+BAA+B;EAC5C,YAAY;EACZ,kBAAkB,EAAE,kBAAkB;EACtC,iBAAiB,EAAE,gCAAgC;AACrD;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,0BAA0B;AACpD;;AAEA;EACE,eAAe;EACf,iBAAiB,EAAE,2BAA2B;AAChD;;AAEA;EACE,mBAAmB,EAAE,mCAAmC;EACxD,cAAc,EAAE,0BAA0B;EAC1C,aAAa,EAAE,sCAAsC;EACrD,mBAAmB,EAAE,sBAAsB;AAC7C;;AAEA;EACE,gBAAgB;EAChB,UAAU,EAAE,oBAAoB;EAChC,WAAW,EAAE,oBAAoB;EACjC,yBAAyB,EAAE,gBAAgB;EAC3C,kBAAkB,EAAE,qBAAqB;EACzC,iBAAiB,EAAE,+BAA+B;AACpD;;AAEA;EACE,aAAa,EAAE,4BAA4B;EAC3C,YAAY,EAAE,0BAA0B;EACxC,gBAAgB,EAAE,2BAA2B;EAC7C,kBAAkB;EAClB,yBAAyB,EAAE,8BAA8B;AAC3D;;AAEA;EACE,aAAa;EACb,cAAc,EAAE,uCAAuC;AACzD;;AAEA;EACE,2BAA2B,EAAE,gCAAgC;EAC7D,iBAAiB;AACnB;;AAEA;EACE,yBAAyB,EAAE,kCAAkC;EAC7D,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB,EAAE,kDAAkD;EACrE,eAAe;EACf,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW,EAAE,gBAAgB;EAC7B,YAAY;EACZ,kBAAkB,EAAE,oBAAoB;EACxC,cAAc,EAAE,wBAAwB;AAC1C;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,YAAY,EAAE,4BAA4B;EAC1C,gBAAgB,EAAE,uCAAuC;EACzD,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,cAAc;EACd,iBAAiB;AACnB;;;AAGA,2BAA2B;AAC3B;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;;AAGA,wCAAwC;AACxC;EACE,sBAAsB;EACtB,sBAAsB;AACxB;;;AAGA,gCAAgC;AAChC;EACE,cAAc,EAAE,uCAAuC;EACvD,4CAA4B;AAC9B;;AAEA,wDAAwD;AACxD;EACE,wCAAwC;EACxC,kBAAkB;EAClB,YAAY;EACZ,8CAA8B;AAChC;;AAEA,yCAAyC;AACzC;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,iCAAiC;AACjC;EACE;;IAEE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,uDAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,6BAA6B,EAAE,qCAAqC;EACpE,kBAAkB;EAClB,mDAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;AAC3B;;AAEA,0DAA0D;AAC1D;EACE,WAAW,EAAE,2BAA2B;EACxC,mBAAmB,EAAE,oBAAoB;AAC3C;;AAEA;EACE,yBAAyB,EAAE,iCAAiC;EAC5D,mBAAmB,EAAE,kCAAkC;AACzD;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;AACvD;;AAEA,iCAAiC;AACjC;EACE,qBAAqB,EAAE,+BAA+B;EACtD,gCAAgC,EAAE,gCAAgC;AACpE;;AAEA;EACE,mBAAmB,EAAE,gCAAgC;AACvD;;AAEA,sEAAsE;AACtE;EACE,mBAAmB,EAAE,gBAAgB;AACvC;;AAEA;EACE,yBAAyB,EAAE,iCAAiC;EAC5D,mBAAmB,EAAE,kCAAkC;AACzD;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;AACvD;;AAEA,kCAAkC;AAClC;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB,EAAE,wBAAwB;EACjD,mBAAmB,EAAE,sBAAsB;EAC3C,aAAa;EACb,yBAAyB,EAAE,4CAA4C;EACvE,WAAW,EAAE,oDAAoD;AACnE;;AAEA;EACE,oCAAoC,EAAE,qCAAqC;EAC3E,sBAAsB;EACtB,8BAA8B;EAC9B,6BAA6B;EAC7B,oBAAoB,EAAE,sBAAsB;AAC9C;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA6BG;;AAEH;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,4CAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;;;IAGE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,qBAAqB;AACrB;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,cAAc,EAAE,eAAe;AACjC;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;EACrD,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;GAIG;;AAEH;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC,EAAE,uBAAuB;AAC/D;;AAEA;EACE,cAAc,EAAE,0BAA0B;AAC5C;;AAEA;EACE,cAAc,EAAE,wBAAwB;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC,EAAE,qCAAqC;EAC3E,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb","sourcesContent":["\n.outerContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh; /* Full height for centering */\n  background-color: #edf6f778; /* Light background for contrast */\n}\n\n.chatContainer {\n  width: 100%; /* Full width for chat container */\n  height: 100%; /* Full height for chat container */\n  max-width: 1300px;\n  max-height: 1200px;\n  overflow: hidden !important;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */\n  display: flex;\n  flex-direction: column !important;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem;\n  background-color: #ffffff; /* White background for the header */\n  border-bottom: 1px solid #e0e0e0; /* Separator line */\n}\n\n.botInfo {\n  display: flex;\n  align-items: center;\n}\n\n.botIcon {\n  width: 50px; /* Fixed size for consistency */\n  height: 50px;\n  border-radius: 50%; /* Circular icon */\n  margin-right: 5px; /* Space between icon and text */\n}\n\n.botDetails {\n  display: flex;\n  flex-direction: column; /* Stack name and status */\n}\n\n.botName {\n  font-size: 17px;\n  font-weight: bold; /* Bold font for bot name */\n}\n\n.onlineStatus {\n  font-size: 0.775rem; /* Smaller font for online status */\n  color: #6c757d; /* Gray color for status */\n  display: flex; /* Use flexbox to align dot and text */\n  align-items: center; /* Center vertically */\n}\n\n.statusDot {\n  margin-left: 5px;\n  width: 8px; /* Size of the dot */\n  height: 8px; /* Size of the dot */\n  background-color: #4caf50; /* Green color */\n  border-radius: 50%; /* Make it circular */\n  margin-right: 5px; /* Space between dot and text */\n}\n\n.chatWindow {\n  padding: 1rem; /* Space for chat messages */\n  flex-grow: 1; /* Take remaining height */\n  overflow-y: auto; /* Scrollable chat window */\n  overflow-x: hidden;\n  background-color: #ffffff; /* White background for chat */\n}\n\n.messageContainer {\n  display: flex;\n  margin: 10px 0; /* Adjusted margin for closer spacing */\n}\n\n.leftMessage {\n  justify-content: flex-start; /* Align left for bot messages */\n  text-align: start;\n}\n\n.rightMessage {\n  justify-content: flex-end; /* Align right for user messages */\n  text-align: start;\n}\n\n.message {\n  padding: 15px 15px; \n  border-radius: 10px;\n  align-items: center; \n  display: flex;\n  max-width: 50%; \n  color: #333;\n  position: relative; \n  word-wrap: break-word;\n  overflow-wrap: anywhere; \n  white-space: pre-wrap; \n}\n\n.soundButton {\n  margin-left: 10px; /* Add space between the text and the sound icon */\n  cursor: pointer;\n  transition: color 0.3s;\n  align-self: flex-end;\n}\n\n.soundButton:hover {\n  color: #333;\n}\n\n.botMessage {\n  background-color: #ebeaea; \n}\n\n.userMessage {\n  background-color: #c8e6c9; \n}\n\n.avatar {\n  width: 50px; /* Avatar size */\n  height: 50px;\n  border-radius: 50%; /* Circular avatar */\n  margin: 0 10px; /* Space around avatar */\n}\n\n/* Input Section */\n.inputSection {\n  display: flex;\n  align-items: center;\n  padding: 10px 15px;\n  background-color: #ffffff;\n  border-radius: 0 0 20px 20px;\n  position: sticky;\n  bottom: 0;\n}\n\n/* Wrapper for the custom input */\n.inputWrapper {\n  display: flex;\n  align-items: flex-end;\n  padding: 4px 8px;\n  /* border: 1px solid #e0e0e0; */\n  border-radius: 20px;\n  background-color: #ebeaea;\n  margin-right: 16px; \n  position: relative;\n  width: 100%;\n  /* min-width: 300px; */\n  max-width: 1000px; \n  margin: 0 auto;\n}\n\n/* Custom input styling */\n.customInput {\n  flex-grow: 1;\n  border: transparent;\n  outline: none;\n  background-color: transparent;\n  padding: 8px;\n  font-size: 1rem;\n  line-height: 24px;\n  resize: none; /* Disable manual resizing */\n  overflow-y: auto; /* Add scrollbar if content overflows */\n  color: inherit;\n}\n\n/* Attachment button styling */\n.attachButton {\n  color: inherit;\n  margin-right: 8px;\n}\n\n\n/* Mic button positioning */\n.micButton {\n  color: inherit;\n  margin-right: 8px;\n  transition: all 0.3s ease;\n}\n\n/* Send Button styling */\n.sendButton {\n  background-color: #c9d1d8;\n  color: #000;\n  border: none;\n  border-radius: 50%;\n  padding: 10px;\n  width: 40px;\n  height: 40px;\n  transition: background-color 0.3s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.disabledButton {\n  opacity: 0.5;\n  cursor: not-allowed; \n}\n\n\n/* Dark mode styling for input wrapper */\n.darkInputWrapper {\n  background-color: #333;\n  border: 1px solid #555;\n}\n\n\n/* Pulse effect when listening */\n.micButton.listening {\n  color: #ff4081; /* Color to indicate active listening */\n  animation: pulse 1s infinite;\n}\n\n/* Add pulse effect around the mic icon when listening */\n.listeningPulse {\n  border: 3px solid rgba(0, 150, 255, 0.5);\n  border-radius: 50%;\n  padding: 8px;\n  animation: pulse 1.5s infinite;\n}\n\n/* Pulsing animation for listening mode */\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.2);\n    opacity: 0.8;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* Listening waveform animation */\n@keyframes wave {\n  0%,\n  100% {\n    transform: scaleY(1);\n  }\n  50% {\n    transform: scaleY(1.5);\n  }\n}\n\n.listeningWave {\n  display: flex;\n  gap: 2px;\n}\n\n.waveBar {\n  width: 5px;\n  height: 16px;\n  background: #2196f3;\n  animation: wave 1s infinite ease-in-out;\n  animation-delay: calc(0.2s * var(--i));\n}\n\n.inputWrapper:focus-within {\n  border-color: #000000;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\n}\n\n.spinner {\n  width: 20px;\n  height: 20px;\n  border: 3px solid #ddd;\n  border-top: 3px solid #3f51b5; /* or any color matching your theme */\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Hover effect for send button */\n.sendButton:hover {\n  background-color: #0056b3;\n}\n\n/* Custom scrollbar for WebKit browsers (Chrome, Safari) */\n.chatWindow::-webkit-scrollbar {\n  width: 10px; /* Width of the scrollbar */\n  border-radius: 10px; /* Rounded corners */\n}\n\n.chatWindow::-webkit-scrollbar-thumb {\n  background-color: #007bff; /* Color of the scrollbar thumb */\n  border-radius: 10px; /* Rounded corners for the thumb */\n}\n\n.chatWindow::-webkit-scrollbar-thumb:hover {\n  background-color: #0056b3; /* Darker color on hover */\n}\n\n/* Custom scrollbar for Firefox */\n.chatWindow {\n  scrollbar-width: thin; /* Make the scrollbar thinner */\n  scrollbar-color: #007bff #f0f4f8; /* Thumb color and track color */\n}\n\n.chatWindow::-moz-scrollbar {\n  border-radius: 10px; /* Rounded corners for Firefox */\n}\n\n/* Optional: Adjust the appearance of the scrollbar track in Firefox */\n.chatWindow::-moz-scrollbar-track {\n  background: #f0f4f8; /* Track color */\n}\n\n.chatWindow::-moz-scrollbar-thumb {\n  background-color: #007bff; /* Color of the scrollbar thumb */\n  border-radius: 10px; /* Rounded corners for the thumb */\n}\n\n.chatWindow::-moz-scrollbar-thumb:hover {\n  background-color: #0056b3; /* Darker color on hover */\n}\n\n/* Add style for the delete icon */\n.deleteIcon {\n  cursor: pointer;\n}\n\n.backButtonContainer {\n  display: flex;\n  justify-content: center; /* Center horizontally */\n  align-items: center; /* Center vertically */\n  padding: 1rem;\n  background-color: #f9f9f9; /* Light background for the button section */\n  width: 100%; /* Ensure the button container takes up full width */\n}\n\n.backButton {\n  background-color: #c9d1d8 !important; /* Color of the Back to Home button */\n  color: #000 !important;\n  border-radius: 20px !important;\n  padding: 10px 20px !important;\n  text-transform: none; /* Disable uppercase */\n}\n\n/* .typingIndicator {\n  display: flex;\n  gap: 5px;\n  margin: 0.5rem 1rem;\n}\n\n.typingDot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: #888;\n  animation: typing 0.8s infinite;\n}\n\n.typingDot:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.typingDot:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes typing {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-5px);\n  }\n} */\n\n.typingDots {\n  display: flex;\n  gap: 4px;\n}\n\n.dot {\n  width: 8px;\n  height: 8px;\n  background-color: #aaa;\n  border-radius: 50%;\n  animation: blink 1s infinite;\n}\n\n.dot:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.dot:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes blink {\n  0%,\n  20%,\n  100% {\n    opacity: 0.2;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n/* Responsive positioning if needed */\n@media (max-width: 600px) {\n  .backButtonContainer {\n    padding: 0.5rem;\n  }\n\n  .backButton {\n    font-size: 0.875rem;\n  }\n}\n\n/* Dark mode styles */\n.dark {\n  background-color: #121212; /* Dark background */\n  color: #f1f1f1; /* Light text */\n}\n\n.dark .chatContainer {\n  background-color: #1e1e1e; /* Darker chat container */\n  color: #f1f1f1;\n}\n\n.dark .chatWindow {\n  background-color: #1e1e1e;\n}\n\n/* .dark .customInput {\n  background-color: #333333; \n  border-color: #444444;\n  color: #ffffff;\n} */\n\n.dark .customInput::placeholder {\n  color: #fff;\n}\n\n.dark .attachButton {\n  color: #fff;\n}\n\n.dark .sendButton {\n  background-color: #444444 !important; /* Darker send button */\n}\n\n.themeToggleIcon {\n  color: #ffeb3b; /* Yellow for light mode */\n}\n\n.dark .themeToggleIcon {\n  color: #ffffff; /* White for dark mode */\n}\n\n.dark .inputSection {\n  background-color: #1e1e1e;\n}\n\n.dark .header {\n  background-color: #1e1e1e;\n}\n\n.dark .backButtonContainer {\n  background-color: #1e1e1e;\n}\n\n.dark .inputWrapper:focus-within {\n  border-color: #fff;\n  box-shadow: 0 0 5px rgba(255, 255, 255, 0.5);\n}\n\n.dark .deleteIcon {\n  color: #fff;\n}\n\n.dark .sendButton {\n  background-color: #333333 !important;\n  color: #fff !important;\n}\n\n.dark .backButton {\n  background-color: #333333 !important; /* Color of the Back to Home button */\n  color: #fff !important;\n}\n\n.dark .micButton {\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"outerContainer": `Demochat_outerContainer__NbVSX`,
	"chatContainer": `Demochat_chatContainer__R157M`,
	"header": `Demochat_header__a6U7y`,
	"botInfo": `Demochat_botInfo__cO2EE`,
	"botIcon": `Demochat_botIcon__X7L6+`,
	"botDetails": `Demochat_botDetails__SPoI5`,
	"botName": `Demochat_botName__5m6zN`,
	"onlineStatus": `Demochat_onlineStatus__0vNuK`,
	"statusDot": `Demochat_statusDot__roNAa`,
	"chatWindow": `Demochat_chatWindow__Qpnh0`,
	"messageContainer": `Demochat_messageContainer__+-7tl`,
	"leftMessage": `Demochat_leftMessage__Nh8mp`,
	"rightMessage": `Demochat_rightMessage__L5bRP`,
	"message": `Demochat_message__5N+NZ`,
	"soundButton": `Demochat_soundButton__cZR2x`,
	"botMessage": `Demochat_botMessage__TYkOS`,
	"userMessage": `Demochat_userMessage__9LfK0`,
	"avatar": `Demochat_avatar__HBPcT`,
	"inputSection": `Demochat_inputSection__3YWwN`,
	"inputWrapper": `Demochat_inputWrapper__0JvZm`,
	"customInput": `Demochat_customInput__BhjH8`,
	"attachButton": `Demochat_attachButton__Yv4Xc`,
	"micButton": `Demochat_micButton__X4rr4`,
	"sendButton": `Demochat_sendButton__awPyU`,
	"disabledButton": `Demochat_disabledButton__UcTrm`,
	"darkInputWrapper": `Demochat_darkInputWrapper__AcBnq`,
	"listening": `Demochat_listening__gv7mR`,
	"pulse": `Demochat_pulse__T4rvJ`,
	"listeningPulse": `Demochat_listeningPulse__uRuxO`,
	"listeningWave": `Demochat_listeningWave__bRg3z`,
	"waveBar": `Demochat_waveBar__LZHSz`,
	"wave": `Demochat_wave__wSkD4`,
	"spinner": `Demochat_spinner__29N-6`,
	"spin": `Demochat_spin__B+K18`,
	"deleteIcon": `Demochat_deleteIcon__n2XTs`,
	"backButtonContainer": `Demochat_backButtonContainer__AJQP4`,
	"backButton": `Demochat_backButton__WGrJc`,
	"typingDots": `Demochat_typingDots__Xzdx6`,
	"dot": `Demochat_dot__tXY9S`,
	"blink": `Demochat_blink__6oOqt`,
	"dark": `Demochat_dark__GagoO`,
	"themeToggleIcon": `Demochat_themeToggleIcon__sBVrN`
};
export default ___CSS_LOADER_EXPORT___;
